// extracted by mini-css-extract-plugin
module.exports = {"docRow":"styles_docRow__1bj-Q","btnWrp":"styles_btnWrp__1CjR1","download":"styles_download__1CJ4x","templateText":"styles_templateText__1pqTG"};